 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		111: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		111: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"12":"121-tutoring-heading-image","13":"ExamBoostAnimation","14":"NoWrongAnswersAnimation","15":"quiz-animation","16":"transfer-subscription-no-children-animation","27":"ChatbotQuitAnimation","28":"ChatbotTypingAnimation","29":"ExamQuestionsUpgradeAnimation","30":"FloralRewardAnimation","31":"SenecaPremiumCardAnimation","32":"accept-challenge-animation","33":"adam-image","34":"all-child-assignments","35":"anonymous-course-discovery-chunk","36":"anonymous-resources-hub","37":"anonymous-resources-hub-chunk","38":"anonymous-what-is-premium-parent","39":"anonymous-what-is-premium-teacher","40":"assignment-share-animation","41":"ben-image","42":"calendar-image","43":"car-animation","44":"child-connected-modal","45":"child-connection-invite-journey","46":"child-not-found-route","47":"child-single-assignment","48":"child-sub-router","49":"circle-books-animation","50":"claim-tutoring-journey","51":"class-page-router","52":"classes-page","53":"classroom-chunk","54":"clock-animation","55":"confetti-animation","56":"correct-answer-animation","57":"courses-page","58":"courses-page-chunk","59":"creation-chunk","60":"cute-whale-animation","61":"dark-mode-toggle-animation","62":"dashboard-router-chunk","63":"date-fns-de","64":"date-fns-de-AT","65":"date-fns-en-AU","66":"date-fns-en-GB","67":"date-fns-en-IN","68":"date-fns-en-US","69":"date-fns-es","70":"date-fns-fr","71":"date-fns-pt-BR","72":"date-fns-vi","73":"dev-tools","74":"empty-desk-animation","75":"exam-prep-topics-animation","76":"feedback-success-animation","77":"front-door-chunk","78":"get-premium-chunk","79":"gostudent-logo-animation","80":"invite-all-school-parents","81":"invite-classes-parents-animation","82":"jane-image","83":"join-group-animation","84":"link-animation","85":"loading-blocks-animation","86":"magnifying-glass-animation","88":"medal-animation","89":"mia-image","90":"mobile-auth","91":"mumsnet-image","92":"new-courses-chunk","93":"no-assignments-animation","94":"no-classes-animation","95":"no-course-info-animation","96":"no-study-time-animation","97":"noStudentsAssignmentsAnimation","98":"parent-claim-tutoring-journey-two-step-routes","99":"parent-dashboard","100":"parent-gift-animation","101":"parent-tutoring-page","102":"parent-tutoring-page-embedded","103":"parent-what-is-premium-page","104":"parents-invite-route","105":"personalised-suggestions-courses-chunk","106":"plug-in-failed-animation","107":"plurall-help-centre-modal-chunk","108":"podium-animation","109":"progress-page","110":"receive-gift-open-animation","112":"sad-look-animation","113":"section-preview","114":"session","115":"settings-page","116":"share-animation","117":"sign-up-invite-chunk","118":"sleepy-animation","119":"smiling-with-hearts-animation","120":"speedyMarkingQuitAnimation","121":"speedyMarkingSuccessAnimation","122":"success-animation","123":"sync-classes-animation","124":"target-animation","125":"teacher-dashboard","126":"topic-score-animation","127":"transfer-subscription-error-animation","128":"transfer-subscription-success-animation","129":"trash-animation","130":"trophy-animation","131":"trustpilot-image","132":"try-a-module","133":"tutoring-activation-journey","134":"weekly-reports-page","135":"what-is-premium-chunk"}[chunkId]||chunkId) + "." + {"0":"08dfa689","1":"3a88774f","2":"45260701","3":"b352d54b","4":"40722546","5":"e74e5c6a","6":"869dc991","7":"63373e0c","8":"e256e498","9":"81ff7438","10":"9fa126a0","11":"0e181d65","12":"03a1f710","13":"25c18eb9","14":"ea616124","15":"4b4d5531","16":"bb6c8d32","17":"2cbc6233","18":"d731faa1","19":"3eeaee8e","20":"25495fe6","21":"b2696177","22":"43fed78a","23":"33f5e23a","24":"0c40a690","25":"88800200","26":"a3441e60","27":"5aaa095f","28":"04a7b72f","29":"fc447338","30":"d980d227","31":"9ec5875b","32":"2fbae355","33":"4d4ff7bb","34":"96ab1197","35":"0c9438dd","36":"435dbf77","37":"fda7c4a3","38":"d9e5c7e4","39":"bde29786","40":"a0a5e815","41":"236580c6","42":"bf5502f6","43":"839e5245","44":"6ea00c9d","45":"4be6040e","46":"6d45225a","47":"eb7cee81","48":"ed2973b3","49":"4a700517","50":"37d828cf","51":"b39b11c5","52":"676656ae","53":"204d3b0e","54":"0e10542d","55":"67f31be5","56":"0332e167","57":"003dd26c","58":"596922e4","59":"f9fb19b5","60":"241ec78e","61":"cf03f2b1","62":"92211e0b","63":"41187b80","64":"287b6f96","65":"d3321998","66":"47ce6dd7","67":"b9d7eeb2","68":"52757448","69":"1dcafef3","70":"79d00240","71":"53d25c77","72":"ee148607","73":"c8fd8009","74":"5cbcb28a","75":"89845f96","76":"1b870a71","77":"6e95839d","78":"119bb503","79":"1ce8142d","80":"0fa00bd4","81":"cd25a7bf","82":"181b2e33","83":"c2b5a51d","84":"aeaa5d36","85":"b447f7d9","86":"ada026fa","88":"14c22c13","89":"69779a4d","90":"e8cf1094","91":"0cb3ccfb","92":"11eaabcc","93":"2239876f","94":"e9ffc662","95":"e0572981","96":"cb5b59b2","97":"de0c1d8f","98":"003edddf","99":"aa4d6cf1","100":"7e5a9fe3","101":"f3638cba","102":"11efd51d","103":"29118ec5","104":"0649f315","105":"2f0ff7e1","106":"ada8169f","107":"68ce022a","108":"e5471626","109":"fb5a3253","110":"fa6510af","112":"17af8d63","113":"90e584fc","114":"cc267509","115":"2797e9b2","116":"3c3f0a2d","117":"4e9db06f","118":"1c8bc347","119":"75ee898c","120":"dc7c6410","121":"3b61e82e","122":"657b5235","123":"a395cd75","124":"4950be31","125":"90f09310","126":"91e24e7e","127":"6531d65c","128":"afcfc293","129":"600be51c","130":"bbb50d4a","131":"5c02251b","132":"29fe167e","133":"63be7513","134":"f90512c7","135":"4ddc4441","137":"3e00642d","138":"c93128a7","139":"763048b7","140":"8cb595f6","141":"8922d0d3","142":"3ffd459a","143":"78028811","144":"a4f280e1"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"8":1,"17":1,"18":1,"19":1,"21":1,"35":1,"36":1,"37":1,"38":1,"39":1,"47":1,"51":1,"52":1,"53":1,"58":1,"59":1,"62":1,"73":1,"77":1,"78":1,"90":1,"99":1,"103":1,"109":1,"113":1,"114":1,"115":1,"117":1,"125":1,"126":1,"132":1,"134":1,"135":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"12":"121-tutoring-heading-image","13":"ExamBoostAnimation","14":"NoWrongAnswersAnimation","15":"quiz-animation","16":"transfer-subscription-no-children-animation","27":"ChatbotQuitAnimation","28":"ChatbotTypingAnimation","29":"ExamQuestionsUpgradeAnimation","30":"FloralRewardAnimation","31":"SenecaPremiumCardAnimation","32":"accept-challenge-animation","33":"adam-image","34":"all-child-assignments","35":"anonymous-course-discovery-chunk","36":"anonymous-resources-hub","37":"anonymous-resources-hub-chunk","38":"anonymous-what-is-premium-parent","39":"anonymous-what-is-premium-teacher","40":"assignment-share-animation","41":"ben-image","42":"calendar-image","43":"car-animation","44":"child-connected-modal","45":"child-connection-invite-journey","46":"child-not-found-route","47":"child-single-assignment","48":"child-sub-router","49":"circle-books-animation","50":"claim-tutoring-journey","51":"class-page-router","52":"classes-page","53":"classroom-chunk","54":"clock-animation","55":"confetti-animation","56":"correct-answer-animation","57":"courses-page","58":"courses-page-chunk","59":"creation-chunk","60":"cute-whale-animation","61":"dark-mode-toggle-animation","62":"dashboard-router-chunk","63":"date-fns-de","64":"date-fns-de-AT","65":"date-fns-en-AU","66":"date-fns-en-GB","67":"date-fns-en-IN","68":"date-fns-en-US","69":"date-fns-es","70":"date-fns-fr","71":"date-fns-pt-BR","72":"date-fns-vi","73":"dev-tools","74":"empty-desk-animation","75":"exam-prep-topics-animation","76":"feedback-success-animation","77":"front-door-chunk","78":"get-premium-chunk","79":"gostudent-logo-animation","80":"invite-all-school-parents","81":"invite-classes-parents-animation","82":"jane-image","83":"join-group-animation","84":"link-animation","85":"loading-blocks-animation","86":"magnifying-glass-animation","88":"medal-animation","89":"mia-image","90":"mobile-auth","91":"mumsnet-image","92":"new-courses-chunk","93":"no-assignments-animation","94":"no-classes-animation","95":"no-course-info-animation","96":"no-study-time-animation","97":"noStudentsAssignmentsAnimation","98":"parent-claim-tutoring-journey-two-step-routes","99":"parent-dashboard","100":"parent-gift-animation","101":"parent-tutoring-page","102":"parent-tutoring-page-embedded","103":"parent-what-is-premium-page","104":"parents-invite-route","105":"personalised-suggestions-courses-chunk","106":"plug-in-failed-animation","107":"plurall-help-centre-modal-chunk","108":"podium-animation","109":"progress-page","110":"receive-gift-open-animation","112":"sad-look-animation","113":"section-preview","114":"session","115":"settings-page","116":"share-animation","117":"sign-up-invite-chunk","118":"sleepy-animation","119":"smiling-with-hearts-animation","120":"speedyMarkingQuitAnimation","121":"speedyMarkingSuccessAnimation","122":"success-animation","123":"sync-classes-animation","124":"target-animation","125":"teacher-dashboard","126":"topic-score-animation","127":"transfer-subscription-error-animation","128":"transfer-subscription-success-animation","129":"trash-animation","130":"trophy-animation","131":"trustpilot-image","132":"try-a-module","133":"tutoring-activation-journey","134":"weekly-reports-page","135":"what-is-premium-chunk"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"5d9248fe","4":"ac707bea","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"20602ede","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"37c4a789","18":"ca93876c","19":"1f6cd108","20":"31d6cfe0","21":"7b591213","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"423c6495","36":"ccef5f62","37":"80aa8eb9","38":"38956ee4","39":"ae252323","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"55915aa3","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"f634c69f","52":"56a4722c","53":"b49b2ead","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"5bbde991","59":"c27a4e34","60":"31d6cfe0","61":"31d6cfe0","62":"58b3f560","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"04824323","74":"31d6cfe0","75":"31d6cfe0","76":"31d6cfe0","77":"6811b781","78":"ff5c18a4","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"31d6cfe0","83":"31d6cfe0","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"7628eb65","91":"31d6cfe0","92":"31d6cfe0","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"31d6cfe0","99":"8182038a","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"f00bebf1","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"31d6cfe0","109":"c677ccf4","110":"31d6cfe0","112":"31d6cfe0","113":"9b12bf8d","114":"8092890d","115":"f969e5f7","116":"31d6cfe0","117":"6811b781","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"0cfd198a","126":"80729292","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"272930af","133":"31d6cfe0","134":"24c2d648","135":"15cf7216","137":"31d6cfe0","138":"31d6cfe0","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpseneca-web"] = this["webpackJsonpseneca-web"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
